import React, { useEffect, useState, Fragment } from 'react';
import {isMonthAndYearEmpty,isNumeric,getStatusFlagValue,getButtonDisabledStates} from '../Custom/Custom'
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import messages from '../assets/Messages.json'
import axios from "axios";
import { API_URL } from '../Constant';
import {showLoading } from 'react-global-loading';

function UrbanWagesData({ 
  urbanWagesRates, 
  mnunicipalName,
  yearName,
  monthName,
  userInfoObject,
  config,
  districtCode,
  resetMothAndYearAndDistrictField,
 districtName,
 averageData,
 averageWeightData,
 monthAndYearValidation,
 payload,
 storedLanguage,
 priceTitle,
 titlesData
 }) {



 
   const [itemData, setItemData] = useState({});
   const [checkedItems, setCheckedItems] = useState([]);
   const navigate = useNavigate();
   const {
    isSaveBtnDisable,
    isSubmitBtnDisable,
    isAcceptBtnDisable,
    isRejectBtnDisable
  } = getButtonDisabledStates(payload, userInfoObject);

   let headQuarterRemark=[
    'Wages is Too Low.',
    'Wages is too High.',
    'Wrong entry'
    ]
    let otherRemark=[
    'High demand of laboures.',
    'Low demand of laboures.',
    'Entry is correct.',
    'Enter has been amended.',
     ]

    

// handle the add row on add row button  click
const addRow = () => {
     let newCustomObject = [];
      for (let i = 0; i < 1; i++) {
        const newItemAdded = {
          id:i,
          "localbodyName": "",
          "establishmentDate": "",
          "rejectRemark": "",
          "localBodyTypeCode": "",
          "localbodyCode": "",
          "masonFirstWage": "",
          "carpenterFirstWage": "",
          "unskilledFirstWage": "",
          "masonSecondWage": "",
          "carpenterSecondWage": "",
          "unskilledSecondWage": "",
          "statusFlag": "",
          "districtCode": "",
          "districtName": "",
          "divisionCode": "",
          "divisionName": "",
          "regionCode": "",
          "regionName": "",
          "validation": "",
          "source": "",
          "remarkFirstUnskilled": "",
          "remarkFirstMason": "",
          "remarkFirstCarpenter": "",
          "remarkSecondUnskilled": "",
          "remarkSecondMason": "",
          "remarkSecondCarpenter": "",
          "masonFirstWageAvg": "",
          "carpenterFirstWageAvg": "",
          "unskilledFirstWageAvg": "",
          "masonSecondWageAvg": "",
          "carpenterSecondWageAvg": "",
          "unskilledSecondWageAvg": "",
          "unskilledWeight": "",
          "masonWeight": "",
          "carpenterWeight": "",
          "unskilledFirstWagesIsRequiredRemark": false,
          "masonFirstWageIsRequiredRemark": false,
          "carpenterFirstWageIsRequiredRemark": false,
          "unskilledSecondWageIsRequiredRemark":false,
          "masonSecondWageIsRequiredRemark":false,
          "carpenterSecondWageIsRequiredRemark":false,
        };
        newCustomObject.push(newItemAdded);
      }
       const dataArray = Object.values(itemData);
       const AddedIndex=dataArray.length
       dataArray.splice(AddedIndex, 0, ...newCustomObject);
       customObjectObjectData(dataArray)
  };

 
// Function to handle update state according to data  
const customObjectObjectData=(responseBlockHData)=>{
  const initialData = {};
    responseBlockHData.forEach((item,index) => {
      initialData[index] = {
      id: index,
      unskilledFirstWage: item?.unskilledFirstWage || '',
      masonFirstWage: item?.masonFirstWage || '',
      carpenterFirstWage: item?.carpenterFirstWage || '',
      unskilledSecondWage: item?.unskilledSecondWage || '',

      masonSecondWage: item?.masonSecondWage ||  '',
      carpenterSecondWage: item?.carpenterSecondWage || '',
      localbodyCode : item?.localbodyCode || '',
      localbodyName: "",
      establishmentDate: "",
      rejectRemark: item?.rejectRemark || '',
      localBodyTypeCode: item?.localBodyTypeCode || '',
      statusFlag: item?.statusFlag || '',
      districtCode: "",
      districtName: "",
      divisionCode: "",
      divisionName: "",
      regionCode: "",
      regionName: "",
      validation: "",
      source: "",
      remarkFirstUnskilled: item?.remarkFirstUnskilled || '',
      remarkFirstMason: item?.remarkFirstMason || '',
      remarkFirstCarpenter: item?.remarkFirstCarpenter || '',
      remarkSecondUnskilled: item?.remarkSecondUnskilled || '',
      remarkSecondMason: item?.remarkSecondMason || '',
      remarkSecondCarpenter: item?.remarkSecondCarpenter || '',

      masonFirstWageAvg: item?.masonFirstWageAvg || 0 ,
      carpenterFirstWageAvg: item?.carpenterFirstWageAvg || 0 ,
      unskilledFirstWageAvg: item?.unskilledFirstWageAvg || 0 ,
      masonSecondWageAvg: item?.masonSecondWageAvg || 0 ,
      carpenterSecondWageAvg: item?.carpenterSecondWageAvg || 0 ,
      unskilledSecondWageAvg: item?.unskilledSecondWageAvg || 0 ,
      unskilledWeight: item?.unskilledWeight ?? item?.unskilled_weight ?? "",
      masonWeight: item?.masonWeight ?? item?.mason_weight ?? "",
      carpenterWeight: item?.carpenterWeight ?? item?.carpenter_weight ?? "",
      unskilledFirstWagesIsRequiredRemark: item?.unskilledFirstWagesIsRequiredRemark ||  false ,
      masonFirstWageIsRequiredRemark: item?.masonFirstWageIsRequiredRemark ||  false ,
      carpenterFirstWageIsRequiredRemark: item?.carpenterFirstWageIsRequiredRemark ||  false,
      unskilledSecondWageIsRequiredRemark:item?.unskilledSecondWageIsRequiredRemark ||  false,
      masonSecondWageIsRequiredRemark:item?.masonSecondWageIsRequiredRemark ||  false,
      carpenterSecondWageIsRequiredRemark:item?.carpenterSecondWageIsRequiredRemark ||  false,
      unskilledFirstWagesStyle: item?.unskilledFirstWagesStyle ||  '',
      masonFirstWageStyle:item?.masonFirstWageStyle ||  '',
      carpenterFirstWageStyle:item?.carpenterFirstWageStyle ||  '',
      unskilledSecondWageStyle:item?.unskilledSecondWageStyle ||  '',
      masonSecondWageStyle:item?.masonSecondWageStyle ||  '',
      carpenterSecondWageStyle:item?.carpenterSecondWageStyle ||  '',
      remarkFirstUnskilledSelectValue:  item?.remarkFirstUnskilledSelectValue || '',
      remarkFirstMasonSelectValue: item?.remarkFirstMasonSelectValue || '',
      remarkFirstCarpenterSelectValue: item?.remarkFirstCarpenterSelectValue || '',
      remarkSecondUnskilledSelectValue:item?.remarkSecondUnskilledSelectValue || '',
      remarkSecondMasonSelectValue:item?.remarkSecondMasonSelectValue || '',
      remarkSecondCarpenterSelectValue: item?.remarkSecondCarpenterSelectValue || '',

    };
  });

  setItemData(initialData);

}


    // Function to handle the store chckbox checked data 
 const handleCheckboxChange = (event, index) => {
  if (event.target.checked) {
    setCheckedItems([...checkedItems, index]);
  } else {
    setCheckedItems(checkedItems.filter((item) => item !== index));
  }
 }


  // Function to handle delete row
const deleteRows = () => {
  const dataArray = Object.values(itemData);

  if(checkedItems.length===0){
    toast.error(`Please check the checkbox`, messages.COLOR_RED);
    return false;
  }
  
  if(dataArray.length>1){
    const updatedItems = dataArray.filter((_, index) => !checkedItems.includes(index));
    customObjectObjectData(updatedItems)
    setCheckedItems([]);
  }else{
    toast.error(`Row cannot be deleted`, messages.COLOR_RED);
  }

};




  

  useEffect(() => {
  
    const initialData = {};
    urbanWagesRates.forEach((item,i) => {
      initialData[i] = {
        id:i,
        unskilledFirstWage: item?.unskilledFirstWage || '',
        masonFirstWage: item?.masonFirstWage || '',
        carpenterFirstWage: item?.carpenterFirstWage || '',
        unskilledSecondWage: item?.unskilledSecondWage || '',

        masonSecondWage: item?.masonSecondWage ||  '',
        carpenterSecondWage: item?.carpenterSecondWage || '',
        localbodyCode : item?.localbodyCode || '',

        remarkFirstUnskilled: item?.remarkFirstUnskilled ||'' ,
        remarkFirstMason:  item?.remarkFirstMason ||'' ,
        remarkFirstCarpenter:  item?.remarkFirstCarpenter ||'' ,
        
        remarkSecondUnskilled:  item?.remarkSecondUnskilled ||'' ,
        remarkSecondMason:  item?.remarkSecondMason ||'' ,
        remarkSecondCarpenter: item?.remarkSecondCarpenter ||'' ,
        
        masonFirstWageAvg: item?.masonFirstWageAvg || 0 ,
        carpenterFirstWageAvg: item?.carpenterFirstWageAvg || 0 ,
        unskilledFirstWageAvg: item?.unskilledFirstWageAvg || 0 ,
        masonSecondWageAvg: item?.masonSecondWageAvg || 0 ,
        carpenterSecondWageAvg: item?.carpenterSecondWageAvg || 0 ,
        unskilledSecondWageAvg: item?.unskilledSecondWageAvg || 0 ,
        localBodyTypeCode: item?.localBodyTypeCode || '',
        rejectRemark :item?.rejectRemark || '',
        statusFlag :item?.statusFlag || '',

        isRequiredRemark:false,
        unskilledFirstWagesStyle: '',
        masonFirstWageStyle:'',
        carpenterFirstWageStyle:'',
        unskilledFirstWagesIsRequiredRemark: false,
        masonFirstWageIsRequiredRemark: false,
        carpenterFirstWageIsRequiredRemark: false,
        unskilledSecondWageStyle:'',
        masonSecondWageStyle:'',
        carpenterSecondWageStyle:'',
        unskilledSecondWageIsRequiredRemark:false,
        masonSecondWageIsRequiredRemark:false,
        carpenterSecondWageIsRequiredRemark:false,
        unskilledFirstWageRemark:'',
          
        remarkFirstUnskilledSelectValue:  item?.remarkFirstUnskilledSelectValue || item?.remarkFirstUnskilled,
        remarkFirstMasonSelectValue: item?.remarkFirstMasonSelectValue || item?.remarkFirstMason,
        remarkFirstCarpenterSelectValue: item?.remarkFirstCarpenterSelectValue || item?.remarkFirstCarpenter,
        remarkSecondUnskilledSelectValue:item?.remarkSecondUnskilledSelectValue || item?.remarkSecondUnskilled,
        remarkSecondMasonSelectValue:item?.remarkSecondMasonSelectValue || item?.remarkSecondMason,
        remarkSecondCarpenterSelectValue: item?.remarkSecondCarpenterSelectValue || item?.remarkSecondCarpenter,
        unskilledWeight: item?.unskilledWeight ?? item?.unskilled_weight ?? '',
        masonWeight: item?.masonWeight ?? item?.mason_weight ?? '',
        carpenterWeight: item?.carpenterWeight ?? item?.carpenter_weight ?? '',
      };
    });

    setItemData(initialData);
  }, [urbanWagesRates]);


  const handleCheckVariation = (localbodyCode, styleField,remarkRequiredField,newValue, average, variation) => {
    if (!(isMonthAndYearEmpty(monthName, yearName))) {
        return;
    }

    let dynamicStylesForTextBox = {};
    let isRequiredRemark = false;

    if (newValue !== 0) {
        let dif = average * variation / 100;
        if (variation === 0 || dif === 0) {
            return;
        }
        if (newValue > (parseFloat(average) + dif) || newValue < (average - dif)) {
            toast.error(messages.VARIATION_MSG, messages.COLOR_RED);
            dynamicStylesForTextBox = {
                borderColor: 'rgb(220, 223, 225) rgb(220, 223, 225) rgb(220, 223, 225) red',
                borderStyle: 'solid',
                borderWidth: '1px 1px 1px 6px'
            };
             newValue = dynamicStylesForTextBox;
             isRequiredRemark = true;
            

        } else {
            dynamicStylesForTextBox = {
                borderColor: '#dcdfe1',
                borderStyle: 'solid',
                borderWidth: '1px 1px 1px 6px'
            };
            isRequiredRemark = false;
            newValue = dynamicStylesForTextBox;
        }
    }

    setItemData(prevItemData => ({
        ...prevItemData,
        [localbodyCode]: {
            ...prevItemData[localbodyCode],
            [styleField]: newValue,
            [remarkRequiredField]: isRequiredRemark
        }
    }));
  
};




const handleOnChange=async(indexId, field, newValue)=>{

  if(!isNumeric(newValue) && field !=='rejectRemark'){
    toast.error(messages.NUMERIC_MSG, messages.COLOR_RED);
    toast.error(" Are you sure, 0 can be enterd?", messages.COLOR_RED);
    newValue='0';
  }


if (field === 'localbodyCode') {

    if (monthName === '' || yearName === '') {
      toast.error(monthName === '' ? messages.MONTH_MSG : messages.YEAR_NAME_MSG, messages.COLOR_RED);
      newValue = ''; 
    } else {
   
      const foundObject = Object.values(itemData).find(item => parseInt(item.localbodyCode) === parseInt(newValue));
      if (foundObject) {
        toast.error(messages.MUNICIPAL_NAME, messages.COLOR_RED);
        newValue = '';
      }
    }
  }




        if (field === 'localbodyCode') {
          let wage_avg='';
          let payload= {
            municipal_code: newValue,
            district_code: districtCode,
            month_name: monthName,
            year_name: yearName
          }
        try {
          showLoading(true);
          const response = await axios.post(`${API_URL}api/labourWages/getLwsUrbanAverage`,payload, config);
           wage_avg=response.data.data.lwsaverage[0];
         
    
          
        }catch (error) {

        }

          setItemData(prevItemData => {
            const updatedItemData = {
              ...prevItemData,
              [indexId]: {
              ...prevItemData[indexId],
              [field]: newValue,
              'unskilledFirstWageAvg':wage_avg.unskilled_first_wage_avg,
              'masonFirstWageAvg':wage_avg.mason_first_wage_avg,
              'carpenterFirstWageAvg':wage_avg.carpenter_first_wage_avg,

              'unskilledSecondWageAvg':wage_avg.unskilled_second_wage_avg,
              'masonSecondWageAvg':wage_avg.mason_second_wage_avg,
              'carpenterSecondWageAvg':wage_avg.carpenter_second_wage_avg,
              
              }
            };
              return updatedItemData;
            });
            showLoading(false);
        }else{
          setItemData(prevItemData => {
            const updatedItemData = {
              ...prevItemData,
              [indexId]: {
              ...prevItemData[indexId],
              [field]: newValue,
              // 'isRequiredRemark': isRequiredRemark
              }
            };
              return updatedItemData;
            });
        }

  }



  const remarkDropDown = ( item, i,selectedValueKey, forRemarkTextKey) => {
  
      let headQuarterSelected='';
      let otherSelected='';

      if(headQuarterRemark.includes(item[forRemarkTextKey])){
        headQuarterSelected=item[forRemarkTextKey]
      }
      if(otherRemark.includes(item[forRemarkTextKey])){
        otherSelected=item[forRemarkTextKey]
      }
    return (
      <>

      {
        (userInfoObject.userLevel !=='HEAD QUARTER') &&   
        (!otherRemark.includes(item[forRemarkTextKey])) && item[forRemarkTextKey] &&
        <label className="text-danger danger_msg_fontSize">{ item[forRemarkTextKey]}</label>
      }
            {
        (userInfoObject.userLevel === 'HEAD QUARTER') &&   
        (!headQuarterRemark.includes(item[forRemarkTextKey])) && item[forRemarkTextKey] &&
        <label className="text-danger danger_msg_fontSize">{ item[forRemarkTextKey]}</label>
        }
      
         
         { userInfoObject.userLevel==='HEAD QUARTER'?
          <select
          key={`thead-${i}`}
          className="form-select"
          name={`${selectedValueKey}${i}`}
          id={`${selectedValueKey}${i}`}
          value={headQuarterSelected?headQuarterSelected:item[selectedValueKey]}
          onChange={e => handleOnChangeRemark(item.id, selectedValueKey,forRemarkTextKey, e.target.value)}
          >
          <option value="">[--Select--]</option>
          { headQuarterRemark.map((remarkItem,i)=>{
            return (
            <option value={remarkItem} key={i}>{++i}</option>

          )})}
          </select>
          
         :
          <select
          key={`thead-${i}`}
          className="form-select"
          name={`${selectedValueKey}${i}`}
          id={`${selectedValueKey}${i}`}
          value={otherSelected?otherSelected:item[selectedValueKey]}
          onChange={e => handleOnChangeRemark(item.id, selectedValueKey,forRemarkTextKey, e.target.value)}
          >

          <option value="">[--Select--]</option>
           {otherRemark.map((remarkItem,i)=>{
            return (
            <option value={remarkItem} key={i}>{++i}</option>

           )})}

          </select> 

         }
      
      </>
    );
  };
  
  const handleOnChangeRemark=(indexId, field,forRemarkTextKey, newValue)=>{ //Remark on change
   
    setItemData(prevItemData => {
      const updatedItemData = {
        ...prevItemData,
        [indexId]: {
        ...prevItemData[indexId],
        [field]: newValue,
        [forRemarkTextKey]:''
        }
      };
        return updatedItemData;
      });

    
  }




  // handle save the data
  const handleUrbanWagesFormData=async(e,buttonType)=>{
    if(!monthAndYearValidation()){
      return true;
    }
    if (buttonType === "REJECT") {
      const missingMunicipal = Object.values(itemData).some((item) => {
        const code = item?.localbodyCode;
        return code === undefined || code === null || String(code).trim() === "";
      });
      if (missingMunicipal) {
        toast.error("Please select Municipal Name", messages.COLOR_RED);
        return false;
      }
    }
    let clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel); //button click status flag
    const customItemCodes = [];
    let check = 0;
    let localbodyCodeCheck=0
    let statusFlag = '';
    let isRejectStatus =false;
  
   
    for (let id in itemData) {
        let unskilledFirstWage = itemData[id].unskilledFirstWage;
        let masonFirstWage = itemData[id].masonFirstWage;
        let carpenterFirstWage = itemData[id].carpenterFirstWage;

        let unskilledSecondWage = itemData[id].unskilledSecondWage;
        let masonSecondWage = itemData[id].masonSecondWage;
        let carpenterSecondWage = itemData[id].carpenterSecondWage;

        let localbodyCode = itemData[id].localbodyCode;

        let remarkFirstUnskilled  =itemData[id].remarkFirstUnskilledSelectValue ;
        let remarkFirstCarpenter=itemData[id].remarkFirstCarpenterSelectValue;
        let remarkFirstMason=itemData[id].remarkFirstMasonSelectValue;
        let remarkSecondUnskilled=itemData[id].remarkSecondUnskilledSelectValue;
        let remarkSecondMason=itemData[id].remarkSecondMasonSelectValue;
        let remarkSecondCarpenter=itemData[id].remarkSecondCarpenterSelectValue;

        let unskilledFirstWagesIsRequiredRemark=itemData[id].unskilledFirstWagesIsRequiredRemark;
        let masonFirstWageIsRequiredRemark=itemData[id].masonFirstWageIsRequiredRemark;
        let carpenterFirstWageIsRequiredRemark=itemData[id].carpenterFirstWageIsRequiredRemark;

        let unskilledSecondWageIsRequiredRemark=itemData[id].unskilledSecondWageIsRequiredRemark;
        let masonSecondWageIsRequiredRemark=itemData[id].masonSecondWageIsRequiredRemark;
        let carpenterSecondWageIsRequiredRemark=itemData[id].carpenterSecondWageIsRequiredRemark;
        
        let remark=itemData[0].rejectRemark;

       if(unskilledFirstWage==='' ||
          masonFirstWage==='' ||
          carpenterFirstWage==='' ||
          unskilledSecondWage==='' ||
          masonSecondWage==='' ||
          carpenterSecondWage===''
           ){
            check++;
           }

          if(localbodyCode===''){
            localbodyCodeCheck++;
          }
          
      statusFlag = (itemData[id].statusFlag === '') ? clickButtonStatusFlag : itemData[id].statusFlag; //database Statusflag

      if (buttonType === "REJECT") { //Reject Button click condition
           statusFlag = clickButtonStatusFlag;
            isRejectStatus =true
            if(String(remark || "").trim()===''){
              toast.error(`Please enter the remarks.`, messages.COLOR_RED);
              return false;
            }
      }

      if (buttonType === "ACCEPT" || buttonType === "SAVE" ) { //Accept Button click
          statusFlag = clickButtonStatusFlag;
      }

      if(buttonType ==="SUBMIT"){
          statusFlag = clickButtonStatusFlag;
        }

  if (buttonType !== "REJECT"){
        // text box validation  **********************************
      if(parseInt(unskilledFirstWage)<0 || parseInt(unskilledFirstWage)>=1000){
        toast.error(`Please enter 3 digit number upto 3 decimal place for Unskilled Wage Rate at first port`, messages.COLOR_RED);
        return false;
      }
      if(parseInt(masonFirstWage)<0 || parseInt(masonFirstWage)>=1000){
        toast.error(`Please enter 3 digit number upto 3 decimal place for Mason Wage Rate at first port`, messages.COLOR_RED);
        return false;
      }
      if(parseInt(carpenterFirstWage)<0 || parseInt(carpenterFirstWage)>=1000){
        toast.error(`Please enter 3 digit number upto 3 decimal place for Carpenter Wage Rate at first port`, messages.COLOR_RED);
        return false;
      }


        if(parseInt(unskilledSecondWage)<0 || parseInt(unskilledSecondWage)>=1000){
          toast.error(`Please enter 3 digit number upto 3 decimal place for Unskilled Wage Rate at second port`, messages.COLOR_RED);
          return false;
        }
        if(parseInt(masonSecondWage)<0 || parseInt(masonSecondWage)>=1000){
          toast.error(`Please enter 3 digit number upto 3 decimal place for Mason Wage Rate at second port`, messages.COLOR_RED);
          return false;
        }
        if(parseInt(carpenterSecondWage)<0 || parseInt(carpenterSecondWage)>=1000){
          toast.error(`Please enter 3 digit number upto 3 decimal place for Carpenter Wage Rate at second port`, messages.COLOR_RED);
          return false;
        }

        //Municipal dropDown Validation
        if(localbodyCodeCheck>0){
          toast.error('Please select Municipal Name', messages.COLOR_RED);
          return false;
          }

        //required fied validation
          if(check>0){
            toast.error(`Enter value in all fields, at least 0`, messages.COLOR_RED);
            return false;
          }

          //Remark Field Validation 
          if(unskilledFirstWagesIsRequiredRemark &&  remarkFirstUnskilled===''){
            toast.error(`Please Select Unskilled Wage Rate Reamrk at first port`, messages.COLOR_RED);
            return false;
          }
          if(masonFirstWageIsRequiredRemark &&  remarkFirstMason===''){
          toast.error(`Please Select Mason Wage Rate Reamrk at first port`, messages.COLOR_RED);
          return false;
          }

          if(carpenterFirstWageIsRequiredRemark &&  remarkFirstCarpenter===''){
          toast.error(`Please Select Carpenter Wage Rate Reamrk at first port`, messages.COLOR_RED);
          return false;
          }


          if(unskilledSecondWageIsRequiredRemark &&  remarkSecondUnskilled===''){
            toast.error(`Please Select Unskilled Wage Rate Reamrk at Second port`, messages.COLOR_RED);
            return false;
          }

          if(masonSecondWageIsRequiredRemark &&  remarkSecondMason===''){
          toast.error(`Please Select Mason Wage Rate Reamrk at Second port`, messages.COLOR_RED);
          return false;
          }
          if(carpenterSecondWageIsRequiredRemark &&  remarkSecondCarpenter===''){
            toast.error(`Please Select Carpenter Wage Rate Reamrk at Second port`, messages.COLOR_RED);
            return false;
          }
      
    }


      const customObject = {
          unskilledFirstWage:unskilledFirstWage,
          masonFirstWage:masonFirstWage,
          carpenterFirstWage:carpenterFirstWage,
          unskilledSecondWage:unskilledSecondWage,
          masonSecondWage:masonSecondWage,
          carpenterSecondWage:carpenterSecondWage,
          localbodyCode:localbodyCode,
          

          remarkFirstUnskilled:remarkFirstUnskilled ,
          remarkFirstCarpenter:remarkFirstCarpenter,
          remarkFirstMason:remarkFirstMason,

          remarkSecondUnskilled:remarkSecondUnskilled,
          remarkSecondMason:remarkSecondMason,
          remarkSecondCarpenter:remarkSecondCarpenter,
          district_name:districtName,

          status: isRejectStatus,
          statusFlag: statusFlag,
          remark:remark,

        };
        customItemCodes.push(customObject);
    }

    let postData = {
        itemCodes: customItemCodes,
        payload: {
            month_name: monthName,
            year_name: yearName,
            district_code: districtCode,
            buttonType: buttonType,
		    	  statusButtonFlag:clickButtonStatusFlag
        }
    };
	showLoading(true)
	try {
	
	 const response = await axios.post(`${API_URL}api/labourWages/getUrbanLabourWagesRatesnputFormWithDataSaveToDB`, postData, config);
   if (response.data.status) {
	   toast.success(response.data.message, messages.COLOR_RED);
	 }
   } catch (error) {
	   console.error(error);
	   toast.error('An error occurred while processing your request.', messages.COLOR_RED);
   } finally {
		showLoading(false);
		resetForm()
   }
  }

  const resetForm=()=>{

    const initialData = {};
  
    urbanWagesRates.forEach((item,i) => {
      initialData[i] = {
        id:i,
        unskilledFirstWage: '',
        masonFirstWage:  '',
        carpenterFirstWage:  '',
        unskilledSecondWage:'',

        masonSecondWage:  '',
        carpenterSecondWage:  '',
        localbodyCode : item?.localbodyCode || '',

        remarkFirstUnskilled:'' ,
        remarkFirstMason:'' ,
        remarkFirstCarpenter: '' ,
        
        remarkSecondUnskilled:'' ,
        remarkSecondMason:'' ,
        remarkSecondCarpenter: '' ,
        
        masonFirstWageAvg: 0 ,
        carpenterFirstWageAvg: 0 ,
        unskilledFirstWageAvg: 0 ,
        masonSecondWageAvg: 0 ,
        carpenterSecondWageAvg: 0 ,
        unskilledSecondWageAvg: 0 ,

        isRequiredRemark:false,
        unskilledFirstWagesStyle: '',
        masonFirstWageStyle:'',
        carpenterFirstWageStyle:'',
        unskilledFirstWagesIsRequiredRemark: false,
        masonFirstWageIsRequiredRemark: false,
        carpenterFirstWageIsRequiredRemark: false,
        unskilledSecondWageStyle:'',
        masonSecondWageStyle:'',
        carpenterSecondWageStyle:'',
        unskilledSecondWageIsRequiredRemark:false,
        masonSecondWageIsRequiredRemark:false,
        carpenterSecondWageIsRequiredRemark:false,
        unskilledFirstWageRemark:'',
        
        remarkFirstUnskilledSelectValue: "",
        remarkFirstMasonSelectValue: "",
        remarkFirstCarpenterSelectValue: "",
        remarkSecondUnskilledSelectValue: "",
        remarkSecondMasonSelectValue: "",
        remarkSecondCarpenterSelectValue: "",
        unskilledWeight: item?.unskilledWeight ?? item?.unskilled_weight ?? "",
        masonWeight: item?.masonWeight ?? item?.mason_weight ?? "",
        carpenterWeight: item?.carpenterWeight ?? item?.carpenter_weight ?? "",
      };
    });
    
   setItemData(initialData);
  //  setRemarkText('')
   resetMothAndYearAndDistrictField()
    }

  return (
    
    <div className="card-body">
      {/* <ToastContainer/> */}
      <div className="table-responsive">
        <table
          cellPadding="6"
          className="table table-bordered text-nowrap text-center"
        >
          <thead>
            <tr>
              <th rowSpan="2" colSpan="2">
              {storedLanguage === 'hi' ? priceTitle.hi.MUNICIPAL_NAME : priceTitle.en.MUNICIPAL_NAME}
              </th>
              <th colSpan="6">{storedLanguage === 'hi' ? priceTitle.hi.WAGE_RATES_AT_FIRST_ADDA_PORT : priceTitle.en.WAGE_RATES_AT_FIRST_ADDA_PORT}</th>
              <th colSpan="6">{storedLanguage === 'hi' ? priceTitle.hi.WAGE_RATES_AT_SECOND_ADDA_PORT : priceTitle.en.WAGE_RATES_AT_SECOND_ADDA_PORT}</th>
            </tr>
            <tr>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.UNSKILLED : priceTitle.en.UNSKILLED}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.REMARKS : priceTitle.en.REMARKS}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.MASON : priceTitle.en.MASON}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.REMARKS : priceTitle.en.REMARKS}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.CARPENTER : priceTitle.en.CARPENTER}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.REMARKS : priceTitle.en.REMARKS}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.UNSKILLED : priceTitle.en.UNSKILLED}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.REMARKS : priceTitle.en.REMARKS}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.MASON : priceTitle.en.MASON}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.REMARKS : priceTitle.en.REMARKS}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.CARPENTER : priceTitle.en.CARPENTER}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.REMARKS : priceTitle.en.REMARKS}</th>
            </tr>
          </thead>

          <tbody>
            {
         
              Object.values(itemData).map((item,i) => {
     
               

                 return (
                  <tr key={i}>
                     <td>
                     {i !==0 &&
                      <input
                      type="checkbox"
                      id={`checkbox-${i}-id`}
                      checked={checkedItems.includes(i)}
                      onChange={(event) => handleCheckboxChange(event, i)}
                      />
                       }
                       </td>
                    <td>
                      <select 
                        className="form-select"
                        name={`mnunicipalName${i}`}
							          id={`mnunicipalName${i}`} 
                        value={itemData[item.id]?.localbodyCode || ''}
                        disabled={isSubmitBtnDisable || isAcceptBtnDisable || isRejectBtnDisable || isSaveBtnDisable}
                        onChange={e => handleOnChange(item.id, 'localbodyCode', e.target.value)}
                       >
                        <option value="">Select</option>
                        {mnunicipalName.map((nm, i) => {
                          return (
                            <>
                              <option key={i} value={nm.localbody_code}>
                                {nm.localbody_name} 
                              </option>
                            </>
                          );
                        })}
                      </select>
                    </td>

                    <td>
                    
                      <input
                        type="text"
                        className="form-control"
                        name={`unskilled_first${i}`}
                        id={`unskilled_first${i}`}
                        style={itemData[item.id]?.unskilledFirstWagesStyle || {}}
                        value={itemData[item.id]?.unskilledFirstWage || ""}
                        onChange={e => handleOnChange(item.id, 'unskilledFirstWage', e.target.value)}
                        onBlur={e=>handleCheckVariation(item.id, 'unskilledFirstWagesStyle','unskilledFirstWagesIsRequiredRemark', parseFloat(e.target.value),item.unskilledFirstWageAvg,10)}
                        maxLength="6"
                      />
                    </td>  

                    <td>
                      {remarkDropDown(item,i,'remarkFirstUnskilledSelectValue','remarkFirstUnskilled')}
                    </td>

                    <td>
                      <input 
                      type="text" 
                       className="form-control"
                       name={`mason_first${i}`}
                       id={`mason_first${i}`}
                       value={itemData[item.id]?.masonFirstWage || ""}
                       style={itemData[item.id]?.masonFirstWageStyle || {}}
                       onChange={e => handleOnChange(item.id, 'masonFirstWage', e.target.value)}
                       onBlur={e=>handleCheckVariation(item.id, 'masonFirstWageStyle','masonFirstWageIsRequiredRemark', parseFloat(e.target.value),item.masonFirstWageAvg,10)}
                       maxLength="6"
                      />
                    </td>  

                    <td>
                    {remarkDropDown(item,i,'remarkFirstMasonSelectValue','remarkFirstMason')}
                    </td>

                    <td>
                      <input
                        type="text"
                        className="form-control"
                        name={`carpenter${i}`}
                        id={`Ccarpenter${i}`}
                        value={itemData[item.id]?.carpenterFirstWage || ""}
                        style={itemData[item.id]?.carpenterFirstWageStyle || {}}
                        onChange={e => handleOnChange(item.id, 'carpenterFirstWage', e.target.value)}
                        onBlur={e=>handleCheckVariation(item.id, 'carpenterFirstWageStyle','carpenterFirstWageIsRequiredRemark',parseFloat(e.target.value),item.carpenterFirstWageAvg,10)}
                        maxLength="6"
                      />
                    </td> 

                    <td>
                    {remarkDropDown(item,i,'remarkFirstCarpenterSelectValue','remarkFirstCarpenter')}
                    </td>

                    <td>
                      <input
                        type="text"
                        className="form-control"
                        name={`unskilled_second${i}`}
                        id={`unskilled_second${i}`}
                        value={itemData[item.id]?.unskilledSecondWage || ""}
                        style={itemData[item.id]?.unskilledSecondWageStyle || {}}
                        onChange={e => handleOnChange(item.id, 'unskilledSecondWage', e.target.value)}
                        onBlur={e=>handleCheckVariation(item.id, 'unskilledSecondWageStyle','unskilledSecondWageIsRequiredRemark',parseFloat(e.target.value),item.unskilledSecondWageAvg,10)}
                        maxLength="6"
                      />
                    </td>                    
                    <td>
                    {remarkDropDown(item,i,'remarkSecondUnskilledSelectValue','remarkSecondUnskilled')}
                    </td>

                    <td>
                      <input 
                        type="text" 
                        className="form-control"
                        name={`manson_second${i}`}
                        id={`manson_second${i}`}
                        value={itemData[item.id]?.masonSecondWage || ""} 
                        style={itemData[item.id]?.masonSecondWageStyle || {}}
                        onChange={e => handleOnChange(item.id, 'masonSecondWage', e.target.value)}
                        onBlur={e=>handleCheckVariation(item.id, 'masonSecondWageStyle','masonSecondWageIsRequiredRemark',parseFloat(e.target.value),item.masonSecondWageAvg,10)}
                        maxLength="6"
                      />
                    </td>  

                    <td>
                    {remarkDropDown(item,i,'remarkSecondMasonSelectValue','remarkSecondMason')}
                    </td> 

                    <td>
                      <input 
                      type="text"
                       className="form-control" 
                       name={`carpenter_second${i}`}
                       id={`carpenter_second${i}`}
                       value={itemData[item.id]?.carpenterSecondWage || ""}
                       style={itemData[item.id]?.carpenterSecondWageStyle || {}}
                        onChange={e => handleOnChange(item.id, 'carpenterSecondWage', e.target.value)}
                        onBlur={e=>handleCheckVariation(item.id, 'carpenterSecondWageStyle','carpenterSecondWageIsRequiredRemark',parseFloat(e.target.value),item.carpenterSecondWageAvg,10)} 
                        maxLength="6"
                       />
                    </td>  

                    <td>
                      
                       {remarkDropDown(item,i,'remarkSecondCarpenterSelectValue','remarkSecondCarpenter')}
                    </td> 

                  </tr>
                );
              })

              
            }
         {averageData && (
           <tr>
            <td></td>
            <td><b>Average</b></td>
           
              <>
            <td> 
            {averageData.avgunskilledFirstWage ? averageData.avgunskilledFirstWage.toFixed(2): 0}
            </td>
            <td></td>

            <td>
            {averageData.avgmasonFirstWage ? averageData.avgmasonFirstWage.toFixed(2):0}
            </td>
            <td></td>

            <td>
            {averageData.avgcarpenterFirstWage ? averageData.avgcarpenterFirstWage.toFixed(2):0}
            </td>
            <td></td>

            <td>
            {averageData.avgunskilledSecondWage ? averageData.avgunskilledSecondWage.toFixed(2):0}
            </td>
            <td></td>

            <td>
            {averageData.avgmasonSecondWage ? averageData.avgmasonSecondWage.toFixed(2):0}
            </td>
            <td></td>
            
            <td>
            {averageData.avgcarpenterSecondWage ? averageData.avgcarpenterSecondWage.toFixed(2):0}
            </td>
             </>
      
            <td></td>
           </tr>
           )}
         {/* Weighted Average row: from API response average_weight (Wage Rates At First Adda + Second Adda) */}
         {averageWeightData && Object.keys(averageWeightData).length > 0 && (
           <tr>
            <td></td>
            <td><b>Weighted Average</b></td>
            <>
            <td>{averageWeightData.avgunskilledFirstWage != null ? Number(averageWeightData.avgunskilledFirstWage).toFixed(2) : ''}</td>
            <td></td>
            <td>{averageWeightData.avgmasonFirstWage != null ? Number(averageWeightData.avgmasonFirstWage).toFixed(2) : ''}</td>
            <td></td>
            <td>{averageWeightData.avgcarpenterFirstWage != null ? Number(averageWeightData.avgcarpenterFirstWage).toFixed(2) : ''}</td>
            <td></td>
            <td>{averageWeightData.avgunskilledSecondWage != null ? Number(averageWeightData.avgunskilledSecondWage).toFixed(2) : ''}</td>
            <td></td>
            <td>{averageWeightData.avgmasonSecondWage != null ? Number(averageWeightData.avgmasonSecondWage).toFixed(2) : ''}</td>
            <td></td>
            <td>{averageWeightData.avgcarpenterSecondWage != null ? Number(averageWeightData.avgcarpenterSecondWage).toFixed(2) : ''}</td>
            </>
            <td></td>
           </tr>
         )}
            <tr>
            <td colSpan="3">Remark</td>           
              <td colSpan="11">
                <textarea 
                className="form-control h-auto" 
                rows="3"
                onChange={e => handleOnChange(0, 'rejectRemark', e.target.value)}
                value={itemData[0]?.rejectRemark}
                >
                </textarea>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="row">
        <div className="col-12 text-center pt-3">
          <button
            type="button"
            onClick={addRow}
            disabled={(Object.values(itemData).length===mnunicipalName.length) || (isSubmitBtnDisable || isAcceptBtnDisable || isRejectBtnDisable || isSaveBtnDisable)}
            className="btn btn_orange mx-1"
          >
            AddRow
          </button>

          <button
            type="button"
            onClick={deleteRows}
            disabled={isSubmitBtnDisable || isAcceptBtnDisable || isRejectBtnDisable || isSaveBtnDisable}
            className="btn btn_orange mx-1"
          >
            DeleteRow
          </button>
          
          <button 
            type="button" 
            className={`btn btn_orange mx-1 ${isSaveBtnDisable ? 'disabled' : ''}`}
            onClick={(e)=>handleUrbanWagesFormData(e,'SAVE')} 
          >
            Save
          </button>

          {(userInfoObject.userLevel ==='HEAD QUARTER') ?
          <>
            <button 
            type="submit" 
            className={`btn btn_orange mx-1 ${isAcceptBtnDisable ? 'disabled' : ''}`}
              onClick={(e)=>handleUrbanWagesFormData(e,'ACCEPT')} 
            >
            Accept
           </button>

            <button 
            type="submit" 
            className={`btn btn_orange mx-1 ${isRejectBtnDisable ? 'disabled' : ''}`}
            onClick={(e)=>handleUrbanWagesFormData(e,'REJECT')} 
            >
            Reject
           </button>

           </>
           :

          <button
           type="submit"
           className={`btn btn_orange mx-1 ${isSubmitBtnDisable ? 'disabled' : ''}`}
           onClick={(e) => handleUrbanWagesFormData(e, 'SUBMIT')}
          >
          Submit
          </button>
          
          }
          <button 
            type="reset" 
            className="btn btn_orange mx-1"
            onClick={resetForm} 
            >
            Reset
          </button>

          <button 
          type="button" 
          className="btn btn_orange mx-1" 
          onClick={(e)=>( navigate("/dashboard"))} 
          >
          Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default UrbanWagesData;
